import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { ModalContext } from '@notino/react-styleguide';

import { useLabelEnclosingDialog } from '@hooks/useLabelEnclosingDialog';
import { useScrolledFromTop } from '@hooks/useScrolledFromTop';
import { cx } from '@linaria/core';

import { messages } from '../../messages';

import {
  CloseButton,
  CloseIcon,
  headerScrolledClass,
  modalHeaderWrapperClass,
  modalHeaderWrapperNewDesignClass,
  ModalTitleWrapper,
} from './styled';

const MODAL_TITLE_ID = 'reviewModalTitle';

export const ModalHeader = ({
  isSuccessModal,
  onClose,
}: {
  isSuccessModal?: boolean;
  onClose?: () => void;
}) => {
  const { hideModal } = ModalContext.useModalContext();
  const { formatMessage } = useIntl();
  const { sentinelRef, isScrolled } = useScrolledFromTop();

  const dialogRef = useLabelEnclosingDialog(
    isSuccessModal ? undefined : MODAL_TITLE_ID
  );

  const wrapperClassName = isSuccessModal
    ? modalHeaderWrapperClass
    : modalHeaderWrapperNewDesignClass;

  return (
    <>
      {/* Zero-height marker at the natural top of the scroll container. Once it
          scrolls out of view the sticky close button gains its shadow. */}
      <div ref={sentinelRef} aria-hidden="true" />

      <div
        ref={dialogRef}
        className={cx(
          wrapperClassName,
          // The form header is a solid bar, so the bar itself gets the shadow.
          !isSuccessModal && isScrolled && headerScrolledClass
        )}
      >
        {!isSuccessModal && (
          <ModalTitleWrapper id={MODAL_TITLE_ID}>
            <FormattedMessage {...messages.reviewModalTitle} />
          </ModalTitleWrapper>
        )}

        <CloseButton
          type="button"
          // The success header has no bar, so the floating button gets the shadow.
          className={cx(isSuccessModal && isScrolled && 'isScrolled')}
          onClick={onClose ?? hideModal}
          aria-label={formatMessage(messages.closeModal)}
          aria-keyshortcuts="Escape"
        >
          <CloseIcon />
        </CloseButton>
      </div>
    </>
  );
};
